import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom'
import './index.css'
import logo from './assets/img/loadElement.gif';
import { persistor, store } from "./actions/store";
import { Provider } from "react-redux";
import { PersistGate } from 'redux-persist/integration/react'
import Routes from './components/common/Routes'
import './i18n';
import { Suspense } from 'react';
import { Footer } from '../src/components/common/Footer'

const Loader = () => (
  <div className="App">
    <img src={logo} className="App-logo" alt="loading" />
  </div>
);

const App = () => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Suspense fallback={<Loader />}>
            <Router>
              <Routes />
              <Footer />
            </Router>
        </Suspense>
      </PersistGate>
    </Provider>
  )
}

ReactDOM.render(<App />, document.getElementById('root'))
